import React from 'react';

import share from '../../../images/search.svg';

import { FOHImage } from '../../ingredients';

export const FOHSearch = (props: any) => (
  <FOHImage
    source={{ uri: share }}
    style={{ width: 18, height: 18, ...props.style }}
  />
);
